export default require("history").createBrowserHistory();
